import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`${wizard.url}/agenti/inserimento`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
